export default {
  'admincp-vehicle-category': ['vehicle_category_management'],
  'admincp-business-task': ['business_task_management'],
  'admincp-business': ['business_task_management'],
  'admincp-node-list': ['node_management'],
  'admincp-node-location': ['node_management'],
  'admincp-node-type': ['node_management'],
  'admincp-workflow': ['workflow_management'],
  'admincp-users': ['user_management'],
  'admincp-settings': ['setting_management'],
  'admincp-settings-toll-stations': ['setting_management']
}
